import { Component, OnInit, inject, input, output } from "@angular/core";
import { EventSummary } from "@auvious/cobrowser";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-cobrowse-event-item",
  templateUrl: "./cobrowse-event-item.component.html",
  styleUrls: ["./cobrowse-event-item.component.scss"],
  standalone: false,
})
export class CobrowseEventItemComponent implements OnInit {
  private t = inject(TranslateService);

  readonly item = input<EventSummary>(undefined);

  readonly timeTravel = output<number>();

  ngOnInit(): void {}

  get user() {
    const item = this.item();
    return !!item.user?.metadata?.name
      ? item.user.metadata.name
      : item.user?.metadata?.role
      ? this.t.instant(item.user.metadata.role)
      : item.user?.endpoint;
  }

  get endpoint() {
    return this.item().user?.endpoint;
  }

  goto() {
    this.timeTravel.emit(this.item().time);
  }
}
